export default {
  PublicEmails: {
    as: ({ slug }) => `/organizations/${slug}`,
    href: '/organizations/[slug]'
  }
}